<template>
  <div>
    <h4 class="text-center">Amio Chat</h4>
    <div class="mt-5">
      <form @submit.prevent="promiseConnect = connect()">

        <div class="form-group row mt-3">
          <label class="col-4 text-muted col-form-label">
            Name:
          </label>
          <div class="col-8">
            <input class="form-control"
                   :class="{'is-invalid': isNameInvalid || serverErrorMessage}"
                   v-model="name"/>
            <div v-show="isNameInvalid" class="invalid-feedback">
              Please provide 'Name'.
            </div>
            <div v-show="serverErrorMessage" class="invalid-feedback">
              {{ serverErrorMessage }}
            </div>
          </div>
        </div>

        <div class="row mt-5">
          <div class="col-12 d-flex justify-content-center">
            <button class="btn btn-primary px-5"
                    v-busy-button="promiseConnect">
              Connect
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import channelService from '@/services/amio-api/channel.service'
  import 'vue-awesome/icons/info-circle'

  export default {
    data() {
      return {
        promiseConnect: null,
        isNameInvalid: false,
        name: '',
        serverErrorMessage: ''
      }
    },

    methods: {
      connect() {
        this.clearError()
        if (!this.name) {
          this.isNameInvalid = true
          return
        }

        this.isNameInvalid = false
        const data = {
          type: 'amio_chat',
          name: this.name
        }
        return channelService.create(data, [422])
          .then(channel => {
            this.channel = channel
            this.$router.push({name: 'administration.channel-detail.info', params: {id: channel.id}})
          })
          .catch((err) => {
            if (err.response.status !== 422) return

            const error = err.response.data.errors ? err.response.data.errors[0] : {}
            return this.handleError(error)
          })
          .then(() => {
            this.promiseConnect = null
          })
      },

      clearError() {
        this.serverErrorMessage = ''
      },

      handleError(error) {
        this.serverErrorMessage = error.message
      }
    }
  }
</script>
